/**
 * OWLY CRM - Mock Leads Data
 * Barrel export consolidando datos modulares
 */

import { Lead, LeadStatus } from '@/types';
import { calificadosLeads } from './data/calificados';
import { nuevosLeads } from './data/nuevos';
import { noCalificadosLeads } from './data/no-calificados';
import { clientesLeads } from './data/clientes';

export const mockLeads: Lead[] = [
  ...calificadosLeads,
  ...nuevosLeads,
  ...noCalificadosLeads,
  ...clientesLeads
];

/**
 * Get leads with filters
 */
export interface LeadFilters {
  status?: LeadStatus | LeadStatus[];
  projectId?: string;
  assignedTo?: string;
  minProbability?: number;
  maxProbability?: number;
}

export function getLeads(filters?: LeadFilters): Lead[] {
  let results = [...mockLeads];

  if (!filters) {
    return results;
  }

  // Filter by status
  if (filters.status) {
    const statuses = Array.isArray(filters.status) ? filters.status : [filters.status];
    results = results.filter((lead) => statuses.includes(lead.status));
  }

  // Filter by project
  if (filters.projectId) {
    results = results.filter((lead) => lead.projectId === filters.projectId);
  }

  // Filter by assigned user
  if (filters.assignedTo) {
    results = results.filter((lead) => lead.assignedTo === filters.assignedTo);
  }

  // Filter by AI probability
  if (filters.minProbability !== undefined) {
    results = results.filter((lead) =>
      (lead.ai_close_probability || 0) >= filters.minProbability!
    );
  }

  if (filters.maxProbability !== undefined) {
    results = results.filter((lead) =>
      (lead.ai_close_probability || 0) <= filters.maxProbability!
    );
  }

  return results;
}

/**
 * Get a single lead by ID
 */
export function getLeadById(id: string): Lead | undefined {
  return mockLeads.find((lead) => lead.id === id);
}

/**
 * Get leads count by status
 */
export function getLeadsCountByStatus(): Record<LeadStatus, number> {
  const counts: Record<string, number> = {};

  mockLeads.forEach((lead) => {
    counts[lead.status] = (counts[lead.status] || 0) + 1;
  });

  return counts as Record<LeadStatus, number>;
}

// Export individual arrays for specific use cases
export { calificadosLeads, nuevosLeads, noCalificadosLeads, clientesLeads };
